import { useEffect } from 'react';
import { trackStandardPageViewEventInPostHog } from '../support-and-tracking/analytics-actions';
import { useLocation } from 'react-router';

export const useTrackPostHogPageViews = () => {
    const location = useLocation();

    useEffect(() => {
        trackStandardPageViewEventInPostHog();
    }, [location?.pathname]);
};
